import { FunctionComponent, useEffect, useState } from 'react'
import { Text, toast } from '@conexasaude/conexa-hero'
import { useHistory } from 'react-router'
import Modal from '@/components/RebrandedModal'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { useModalContext } from '@/components/RebrandedModal/contexts/ModalContext'
import services from '@/modules/Auth/auth-services'
import useStyles from './styles'
import { useThemeGeneratorContext } from '@/theme/contexts/ThemeGeneratorContext'

interface TermsAndConditionsModalProps {
  redirectTo: string
  directLogin: () => Promise<void>
  setLoading: (isLoading: boolean) => void
  userToken: string
}

const TermsAndConditionsModal: FunctionComponent<
  TermsAndConditionsModalProps
> = ({ redirectTo, directLogin, setLoading, userToken }) => {
  const { signOut } = useAuthContext()
  const { closeModal, showModal } = useModalContext()
  const { embed } = useThemeGeneratorContext()
  const history = useHistory()

  const [termsUrl, setTermsUrl] = useState('')

  const styles = useStyles()

  const declineTermsAndConditions = () => {
    closeModal()
    signOut(true)
    if (redirectTo) history.push('/termos-recusados')
    else history.push('/login')
  }

  const acceptTermsAndConditions = async () => {
    try {
      closeModal()
      setLoading(true)

      await services.acceptTerm()

      await directLogin()

      setLoading(false)
      const createEmbedUrl = (url?: string) => {
        const parsedUrl = embed.full
          ? `/${url}?embedFull=true`
          : embed.value
          ? `/${url}?embed=true`
          : `/${url}`
        return parsedUrl
      }
      if (redirectTo) {
        window.location.pathname = createEmbedUrl(redirectTo)
      } else {
        window.location.href = createEmbedUrl('')
      }
    } catch (error) {
      setLoading(false)
      showModal('TERMS_AND_CONDITIONS')

      toast({
        message: error.message,
        autoCloseDuration: 3000,
        variant: 'error',
      })
    }
  }

  useEffect(() => {
    if (userToken) {
      setLoading(true)
      services
        .getClinic(userToken)
        .then(res => {
          const clinicTerms = res.clinic.urlTermoPaciente
          setTermsUrl(clinicTerms)
        })
        .catch(() => {
          setTermsUrl(
            'https://s3.sa-east-1.amazonaws.com/drvirtual/downloads/termo_uso_b2c.pdf',
          )
        })
        .finally(() => setLoading(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userToken])

  return (
    <Modal
      id="TERMS_AND_CONDITIONS"
      negativeAction={declineTermsAndConditions}
      negativeActionLabel="Não aceito"
      primaryAction={acceptTermsAndConditions}
      primaryActionLabel="Li e aceito os termos de uso"
    >
      <div css={styles.modalContent}>
        <Text renderAs="p">
          Nós, da <strong>CONEXA SAÚDE</strong>, consideramos que a relação com
          nossos <strong>Usuários</strong> deve ser pautada na maior confiança e
          respeito, para garantir a todos a melhor experiência possível.
        </Text>

        <Text renderAs="p">
          Entendemos que a leitura completa pode levar algum tempo.
        </Text>

        <Text renderAs="p">
          Então, caso não tenha disponibilidade neste momento, apresentamos
          abaixo um pequeno resumo dos pontos mais importantes.
        </Text>

        <Text renderAs="p">
          Para a compreensão completa e leitura total dos termos e condições
          gerais de uso da <strong>Plataforma Conexa Saúde</strong>, leia nossos{' '}
          <a href={termsUrl}>termos e condições gerais de uso</a>.
        </Text>
      </div>
    </Modal>
  )
}

export { TermsAndConditionsModal }
